import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Contract } from 'src/app/core/interfaces/sales-management/contract';
import { ApiService } from 'src/app/core/services/api/api.service';

@Component({
  selector: 'app-sales-management-counts-list',
  templateUrl: './sales-management-counts-list.component.html',
  styleUrls: ['./sales-management-counts-list.component.scss'],
})
export class SalesManagementCountsListComponent implements OnInit {
  @Input() status: string;
  statusMessage: string;
  statusNumber: number;

  displayedColumns: string[] = [];

  pendingApprovalDisplayedColumns: string[] = [
    'contractId',
    'notes',
    'customerName',
    'jobaddress',
    'contractDate',
    'estimator',
    'contractTotal',
  ];

  approvedDoNotScheduleDisplayedColumns: string[] = [
    'contractId',
    'notes',
    'customerName',
    'jobaddress',
    'contractDate',
    'estimator',
    'contractTotal',
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  contractArray: Contract[] = [];
  dataSource: MatTableDataSource<Contract>;

  isLoading: boolean = true;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();
    // this.getContracts(this.status);
    this.route.paramMap.subscribe((params) => {
      this.status = params.get('status') as string;
      this.getContracts(this.status);
    });
  }

  getContracts(status: string) {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();

    if (status) {
      switch (status) {
        case 'pendingApproval':
          this.statusNumber = 0;
          this.statusMessage = 'Contracts Pending Approval';
          this.displayedColumns = this.pendingApprovalDisplayedColumns;
          break;
        case 'approvedDoNotSchedule':
          this.statusNumber = 3;
          this.statusMessage = 'Approved Contracts Do Not Schedule';
          this.displayedColumns = this.approvedDoNotScheduleDisplayedColumns;
          break;
        case 'cancelled':
          this.statusNumber = 2;
          this.statusMessage = 'Cancelled Contracts';
          this.displayedColumns = this.pendingApprovalDisplayedColumns;
          break;
      }
    }

    if (this.statusNumber != undefined) {
      this.apiService.getSalesManagementByStatus(this.statusNumber).subscribe({
        next: (contracts: Contract[]) => {
          this.isLoading = false;
          this.contractArray = contracts;
          this.dataSource = new MatTableDataSource(contracts);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        },
        error: (e) => {
          this.isLoading = false;
          console.error(e);
        },
      });
    }
  }

  goToContract(row: Contract) {
    this.router.navigate(['customers/' + row.customerId], {
      queryParams: {
        jobAddressId: row.jobAddressId,
        contractId: row.contractId,
      },
    });
  }

  filterContracts(event: Event) {
    const filterString = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterString.trim().toLowerCase();
  }
}
